import {generateExportDataSet} from "@containers/export/containers/buildData/helpers/generateDataSet";
import {buildExportDataPdf} from "@containers/export/containers/pdf/helpers/helpers";
import {ExportPdfContent, IExportPdfBaseSettings} from "@containers/export/containers/pdf/types";
import {IColumnItem} from "@ui/tableCustom/types/columns";
import {HeadColumns} from "@ui/tableCustom/types/table";
import {IExportDataSetAdditionalItem} from "@containers/export/containers/buildData/hooks/types/exportParams";
import pdfMake from 'pdfmake'
import pdfFonts from "pdfmake/build/vfs_fonts";

(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;


interface IProps<T> {
    fileName?: string,
    onDownload?: () => void,
    baseSettings?: IExportPdfBaseSettings,
    baseSettingsCb?: (columns: IColumnItem<T>[]) => IExportPdfBaseSettings,
    headerContents?: ExportPdfContent,
    columnExport: IColumnItem<T>[],
    fullColumns: IColumnItem<T>[],
    headColumns?: HeadColumns<T>,
    exportDataFromAllPage?: boolean,
    allData?: T[],
    data: T[],
    additionalDataSet: IExportDataSetAdditionalItem<T>[],
    ignoredExportColumnKey?: string | null,
    order: keyof T | false,
    direction: string,
    t: (key: string) => string,
    exportFromAllColumns?:boolean
}

export const generatePdfFile = async <T>({
                                             fileName,
                                             onDownload,
                                             baseSettings,
                                             baseSettingsCb,
                                             headerContents,

                                             columnExport,
                                             fullColumns,
                                             headColumns,
                                             exportDataFromAllPage,
                                             allData,
                                             data,
                                             additionalDataSet,
                                             order,
                                             direction,
                                             t,
                                             exportFromAllColumns,
                                         }: IProps<T>) => {
    const dataSet = generateExportDataSet({
        columnExport,
        fullColumns,
        headColumns,
        exportDataFromAllPage,
        allData,
        data,
        additionalDataSet,
        order,
        direction,
        t,
        exportFromAllColumns,
    })

    const doc = buildExportDataPdf({
        dataSet,
        baseSettings,
        baseSettingsCb,
        headerContents,
    })

    //@ts-ignore
    await pdfMake.createPdf(doc).download(fileName);
    if (onDownload) {
        onDownload()
    }
}